import React, { PropsWithChildren, ForwardedRef, HTMLProps } from 'react';
import cls from 'classnames';
import _isObject from 'lodash/isObject';

import styles from './Col.scss';

export type BreakPointData = {
  /**
   * Количество занимаемых колонок
   */
  span: number;
  /**
   * Количество колонок, на которое нужно сместиться
   */
  offset?: number;
};

type Props = PropsWithChildren<
  {
    /**
     * Количество занимаемых колонок или более подробный
     * объект с параметрами отображения на декстопе. Если ничего не передать или передать 0, колонка будет скрыта.
     */
    desktop?: BreakPointData | number;
    /**
     * Количество занимаемых колонок или более подробный
     * объект с параметрами отображения на адаптиве. Если ничего не передать или передать 0, колонка будет скрыта.
     */
    mobile?: BreakPointData | number;
    className?: string;
    forwardedRef?: ForwardedRef<HTMLDivElement>;
  } & HTMLProps<HTMLDivElement>
>;

const Col = (props: Props) => {
  const { desktop = 0, mobile = 0, children, className, forwardedRef, ...restProps } = props;

  const desktopSpanValue = _isObject(desktop) ? desktop.span : desktop;
  const mobileSpanValue = _isObject(mobile) ? mobile.span : mobile;

  const desktopOffsetValue = _isObject(desktop) ? desktop.offset : null;
  const mobileOffsetValue = _isObject(mobile) ? mobile.offset : null;

  return (
    <div
      ref={forwardedRef}
      className={cls(
        styles.column,
        styles[`column-desktop-${desktopSpanValue}`],
        styles[`column-mobile-${mobileSpanValue}`],
        {
          [styles[`column-offset-desktop-${desktopOffsetValue}`]]: !!desktopOffsetValue,
          [styles[`column-offset-mobile-${mobileOffsetValue}`]]: !!mobileOffsetValue,
        },
        className
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    >
      {children}
    </div>
  );
};

export const ColWithRef = React.forwardRef((props: Props, ref: ForwardedRef<HTMLDivElement>) => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Col {...props} forwardedRef={ref} />;
});

export default Col;
